import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Container, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../config/api';
import PasswordInput from '../components/PasswordInput';
import './Auth.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token || !token.trim()) {
      toast.error('Invalid reset link. Please request a new one.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await api.post('/user/auth/reset-password', {
        token: token?.trim(),
        newPassword: password,
      });
      setSuccess(true);
      toast.success('Password reset successfully. You can now log in.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (error) {
      toast.error(error.response?.data?.error || 'Failed to reset password. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token || !token.trim()) {
    return (
      <div className="auth-page">
        <Container>
          <div className="auth-card">
            <h1 className="auth-title">Invalid link</h1>
            <p className="auth-subtitle">This reset link is invalid or missing. Please request a new one.</p>
            <div className="auth-switch">
              <p>
                <Link to="/forgot-password">Request new link</Link> · <Link to="/login">Login</Link>
              </p>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-page">
        <Container>
          <div className="auth-card">
            <h1 className="auth-title">Password reset</h1>
            <p className="auth-subtitle">Your password has been updated. Redirecting to login...</p>
            <div className="auth-switch">
              <p>
                <Link to="/login">Go to Login</Link>
              </p>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <Container>
        <div className="auth-card">
          <h1 className="auth-title">Set new password</h1>
          <p className="auth-subtitle">Enter your new password below.</p>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <PasswordInput
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                placeholder="New password (min 6 characters)"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <PasswordInput
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
                placeholder="Confirm new password"
              />
            </Form.Group>

            <Button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? 'Updating...' : 'Reset password'}
            </Button>

            <div className="auth-switch">
              <p>
                <Link to="/login">Back to Login</Link>
              </p>
            </div>
          </Form>
        </div>
      </Container>
    </div>
  );
};

export default ResetPassword;
